import { useState } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/lib/api";

const LINKS = [
  { id: "about", label: "About" },
  { id: "agenda", label: "11-Point Agenda" },
  { id: "constitution", label: "Constitution" },
  { id: "committee", label: "Committee" },
  { id: "donate", label: "Donate" },
  { id: "contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/80 border-b border-yellow-400/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-10 h-16 flex items-center justify-between gap-4">
        <button data-testid="nav-logo-link" onClick={() => go("hero")} className="flex items-center gap-3 shrink-0">
          <img src={ASSETS.logo} alt="RGP Logo" className="h-10 w-10 rounded-full object-cover" />
          <span className="font-display font-extrabold uppercase tracking-wider text-base lg:text-lg text-white leading-none whitespace-nowrap">
            <span className="lg:hidden">RGP</span>
            <span className="hidden lg:inline">Revolutionary <span className="text-yellow-400">Goans Party</span></span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-4 lg:gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono-rgp text-[10px] lg:text-[11px] uppercase tracking-[0.16em] lg:tracking-[0.2em] text-zinc-400 hover:text-yellow-400 transition-colors whitespace-nowrap leading-none"
            >
              {l.label}
            </button>
          ))}
          <button data-testid="nav-join-button" onClick={() => go("membership")} className="btn-yellow !py-2 !px-4 lg:!px-5 !text-base whitespace-nowrap">
            Join RGP
          </button>
        </nav>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-yellow-400 shrink-0 p-1" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black border-t border-yellow-400/15 px-5 py-6 flex flex-col gap-5">
          {[...LINKS, { id: "membership", label: "Join RGP" }].map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left font-display font-bold uppercase tracking-wider text-xl text-white hover:text-yellow-400 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
